import { LotKinds, LotStatus } from '@parallel-fluidics/shared/constants';

// Shared segmented-control options for the lots page tabs — one source
// so Bags and By item can't drift.
export const kindOptions = [
  { text: 'All kinds', id: 'all' },
  ...Object.values(LotKinds).map((kind) => ({ text: kind, id: kind })),
];

export const statusOptions = [
  { text: 'All statuses', id: 'all' },
  ...Object.values(LotStatus).map((status) => ({ text: status, id: status })),
];
